// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"0ae5ffe0","712":"6f656fe2","853":"33858d72"}[chunkId] + ".chunk.js";
};